"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Schedule Trigger',
    description: 'Run flow on schedule',
    isTrigger: true,
});
//# sourceMappingURL=schedule-trigger.js.map